<template v-slot="extension">
  <div>
    <div v-if="isMaster">
      <v-tabs color="primary" slider-color="blue" dark v-model="model">
        <v-tab v-for="i in dashboardTabs" :key="i" :href="`#tab-${i}`">
          {{ getTabTitle(i) }}
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="model">
        <v-tab-item v-for="i in dashboardTabs" :key="i" :value="`tab-${i}`">
          <v-card flat>
            <v-card-text>
              <div v-if="i === 1">
                <dashboard-create-page @created="onFormSave()" />
              </div>
              <div v-else-if="i === 2">
                <dashboard-files-page :incoming-scenario-id="getIncomingScenarioId" />
              </div>
              <div v-else-if="i === 3">
                <dashboard-scenario-page />
              </div>
              <div v-else>
                <dashboard-page />
              </div>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </div>
    <div v-else>
      <dashboard-page />
    </div>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
import DashboardCreatePage from '@/views/Report/DashboardCreatePage'
import DashboardFilesPage from '@/views/Report/DashboardFiles'
import DashboardScenarioPage from '@/views/Config/DashboardScenario/Index'
import DashboardPage from '@/views/Report/DashboardPage'

export default {
  name: 'DashboardsDbManager',
  mounted() {},
  data() {
    return {
      valid: false,
      selectedScenario: -1,
      showForm: true,
      querySelectedScenario: this.$route.query.dashboardScenarioId,
      model: !this.$route.query.dashboardScenarioId ? 'tab-1' : 'tab-2',
      dashboardTabs: 4,
    }
  },
  computed: {
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
    isMaster() {
      return this.clientId == 0
    },
    getIncomingScenarioId() {
      if (!this.querySelectedScenario) {
        return null
      }
      return +this.querySelectedScenario
    },
  },
  methods: {
    onFormSave() {
      setTimeout(() => {
        this.$emit('created')
      }, 600)
    },
    getTabTitle(i) {
      let title = ''
      switch (i) {
        case 1:
          title = 'Launching'
          break
        case 2:
          title = 'Retrieving'
          break
        case 3:
          title = 'Scenario'
          break
        case 4:
          title = 'Creation'
          break
        default:
          title = ' '
          break
      }
      return title
    },
  },
  components: {
    DashboardCreatePage,
    DashboardFilesPage,
    DashboardScenarioPage,
    DashboardPage,
  },
}
</script>
